export var checkPcOrH5 = function () {
    var result = null;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i.test(navigator.userAgent)) {
        // 当前设备为移动端（H5）
        result = 'h5';
    }
    else {
        // 当前设备为桌面显示器（PC）
        result = 'pc';
    }
    return result;
};
